import AsideProfile from './aside-profile.vue'
export default AsideProfile